import React from "react";

export const CoPilotConfig = () => {
  return <div>view</div>;
};
